import React, { useContext, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import ApplicationContext from "../../context/ApplicationContext";
import { IReceipt } from "../../types/IReceipt";
import { IReceiptData } from "../../types/IReceiptData";
import { generateGUID } from "../../helpers/Helper";
import { Message, MessageHeader } from "semantic-ui-react";
import { parkReceipt, updateReceipt } from "../../services/Service";

export interface ParkRestaurantModalProps {
  close(): void;
  success(): void;
  show: boolean;
}

export const ParkRestaurantModal: React.FC<ParkRestaurantModalProps> = (
  props: ParkRestaurantModalProps
): JSX.Element => {
  const context = useContext(ApplicationContext);
  const [isSaving, setIsSaving] = useState(false);
  const [hasError, setHasError] = useState(false);

  function closeModal() {
    props.close();
  }

  function getTotal() {
    let total = 0;
    context.Receipt.getRows().forEach((r) => {
      total += r.qty * r.price;
    });
    return total;
  }

  function findProductByBarcode(barcode: string) {
    return context.Receipt.getRows().find((element) => {
      return element.product.barcode === barcode;
    });
  }

  async function manageTable(print: boolean) {
    setIsSaving(true);
    setHasError(false);

    const rows = context.Receipt.getRows();
    const table = context.Receipt.getTable();

    const rowsJson = JSON.stringify(rows);
    let success = false;

    let description = "parked";
    const product = findProductByBarcode("00000000");

    if (product) {
      description = product.product.description;
    }

    if (table !== undefined) {
      const isSaved = await updateReceipt(
        context.AuthenticatedUser.getToken(),
        table.uuid,
        description,
        rowsJson
      );

      if (isSaved === true) {
        success = true;
      }
    } else {
      const isSaved = await parkReceipt(
        context.AuthenticatedUser.getToken(),
        description,
        rowsJson
      );

      if (isSaved === true) {
        success = true;
      }
    }

    if (success === false) {
      setHasError(true);
      setIsSaving(false);
      return;
    }

    if (print) {
      props.success();
      return;
    }

    setIsSaving(false);
    props.close();
  }

  function findProductByProductId(id: number) {
    return context.BranchMenu.getMenu().products.find((element) => {
      return element.id === id;
    });
  }

  function modalTitle() {
    const description1 = context.Receipt.getTable()?.description1;

    if (description1 === undefined) {
      return "Park";
    }

    return "Update " + description1;
  }

  const errorMessage = () => (
    <>
      <Message negative>
        <MessageHeader>Saving receipt failed</MessageHeader>
        <p>
          Please check your network (internet). If the error persist please
          contact support
        </p>
      </Message>
    </>
  );

  const messageModal = (): JSX.Element => {
    return (
      <>
        <Modal
          show={props.show}
          onHide={() => closeModal()}
          size="xl"
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>{modalTitle()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>
              {hasError ? errorMessage() : <></>}

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  variant="success"
                  style={{ width: 300, height: 100, marginRight: 5 }}
                  onClick={() => manageTable(false)}
                >
                  <h3>{modalTitle()}</h3>
                </Button>
                <Button
                  variant="primary"
                  style={{ width: 300, height: 100, marginRight: 5 }}
                  onClick={() => manageTable(true)}
                >
                  <h3>{modalTitle()} & Print</h3>
                </Button>
              </div>
            </>
          </Modal.Body>
          <Modal.Footer className="modal-footer">
            <div className="mr-auto"></div>
            <div>
              <Button
                variant="success"
                size="lg"
                onClick={() => {
                  setHasError(false);
                  setIsSaving(false);
                  props.close();
                }}
              >
                Cancel
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  return (
    <>
      <>{messageModal()}</>
    </>
  );
};
